import formatWorkerDisplayName from "../utils/formatWorkerDisplayName"

const getInitials = (displayName = "") => {
  const d = displayName.trim()
  if (!d) return "?"
  const parts = d.split(/\s+/)
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toLocaleUpperCase("es-ES")
  const w = parts[0]
  if (w.length >= 2) return w.slice(0, 2).toLocaleUpperCase("es-ES")
  return (w[0] || "?").toLocaleUpperCase("es-ES")
}

const COLORS = [
  "#EF4444","#F97316","#EAB308","#22C55E",
  "#06B6D4","#3B82F6","#8B5CF6","#EC4899",
]

const colorFor = (key = "") => {
  let hash = 0
  for (let i = 0; i < key.length; i++) hash = key.charCodeAt(i) + ((hash << 5) - hash)
  return COLORS[Math.abs(hash) % COLORS.length]
}

const AssigneeAvatar = ({ name, size = 28, user }) => {
  const photoUrl = user?.foto?.url
  const rawName = name || user?.name || ""
  const displayName = formatWorkerDisplayName(rawName) || "?"
  const hashKey = user?.id || user?.email || rawName || displayName
  const initials = getInitials(displayName)
  const bg = colorFor(String(hashKey))

  if (photoUrl) {
    return (
      <img
        src={photoUrl}
        alt={displayName}
        title={displayName}
        className="rounded-full object-cover flex-shrink-0 border-2 border-white"
        style={{ width: size, height: size }}
      />
    )
  }

  return (
    <div
      title={displayName}
      className="rounded-full flex items-center justify-center text-white font-semibold flex-shrink-0 border-2 border-white"
      style={{ width: size, height: size, backgroundColor: bg, fontSize: size * 0.36 }}
    >
      {initials}
    </div>
  )
}

export default AssigneeAvatar
